module.exports = __webpack_public_path__ + "static/media/foodprint_app7.211b656d.jpg";